jQuery(document).ready(function ($) {

    'use strict'

    colorslider();

    function colorslider() {
        $('section.case-slider .slide').each(function () {
            var nr = $(this).index() + 1;
            var targetClass = $(this).data('slide-background');
            setTimeout(function () {
                $('.lSPager li:nth-child(' + nr + ') a').addClass(targetClass);
            }, 800);
        });
    }

    $('section.case-slider .slide').each(function () {
        var nr = $(this).index() + 1;
        var targetClass = $(this).data('slide-background');
        setTimeout(function () {
            $('.lSPager li:nth-child(' + nr + ')').addClass(targetClass);
        }, 800);
    });

    $('body').toggleClass('loaded');

    window.onbeforeunload = function () {
        $('body').addClass('unloading');
    };

    if ($('.wpcf7').length) {
        var wpcf7Elm = document.querySelector('.wpcf7');

        wpcf7Elm.addEventListener('wpcf7mailsent', function (event) {
            var downloadButton = $(this).closest('.bottom.form').find('.button-download');
            $(downloadButton).fadeIn();
        }, false);
    }

    $('.case-slider .slide-holder').lightSlider({
        gallery: true,
        item: 1,
        loop: true,
        thumbItem: 4,
        mode: 'fade',
        slideMargin: 0,
        controls: false,
        enableDrag: false,
        auto: true,
        pause: 4000,
        currentPagerPosition: 'left'
    });

    $('.search-button, .close-button').click(function () {
        $(this).toggleClass('clicked');
        $('.search-bar').toggleClass('show');
        $('html, body').animate({scrollTop: '0'});
        $('.search-bar').find('input[type="text"]').focus();
    });

    var clickCounter = 0;
    var buttonPress = true;


    $('.text-slides').on('click', '.slide-navigation img', function () {
        if (buttonPress == true) {
            buttonPress = false;
            var clickedButton = $(this);

            console.log(buttonPress);

            setTimeout(function () {
                buttonPress = true;
            }, 800);

            clickCounter++;

            $('.visual-slide').each(function () {

                var dataNr = $(this).attr('data-nr');

                var dataNr = parseFloat(dataNr);


                if ($(clickedButton).hasClass('button-next')) {
                    dataNr = dataNr + 1;
                }

                if ($(clickedButton).hasClass('button-previous')) {
                    dataNr = dataNr - 1;
                }


                if (dataNr === 6) {
                    dataNr = 1;
                }

                if (dataNr === 0) {
                    dataNr = 5;
                }

                $(this).removeClass('slide-1 slide-2 slide-3 slide-4 slide-5');
                $(this).addClass('slide-' + dataNr);
                $(this).attr('data-nr', dataNr);

            });


            var textTarget = $('.slide-3').data('text');
            $('.text-slide').fadeOut().promise().done(function () {
                $('.' + textTarget).fadeIn();
            });

        }
    });




    $('.drag-item').draggable({
        axis: 'x',
        containment: 'parent',
        drag: function (event, ui) {
            $(this).css('left', parseInt($(this).css('left')) / ($('.drag-holder').width() / 100) + '%');
            var dragPosition = parseFloat($(this).css('left'));
            var dragContainer = $('.drag-holder').width() / 100;
            var total = dragPosition / dragContainer;
            var totalCss = '-' + total + '%';
            $('.lines').css('left', totalCss);
        }
    });

    $('.year').each(function () {
        var yearData = $(this).data('year');

        var yearCalc = yearData - 1935.6;
        yearCalc = yearCalc * 2.05;

        $(this).css('left', yearCalc + 'rem')
    });

    $('.year').click(function () {
        $('.year').removeClass('clicked');
        $(this).addClass('clicked');

        var targetYear = $(this).data('target-text');

        $('.history-content').fadeOut().promise().done(function () {
            $('.' + targetYear).fadeIn();
        });
    });

    /* Movies */
    $('.bg-video, .bg-video-item').each(function () {
        var videoData = $(this).data('video');
        var posterData = $(this).data('poster');


        $(this).background({

            source: {
                poster: posterData,
                video: 'https://www.youtube.com/watch?v=' + videoData + '&vq=hd1080'
            }
        });
        setTimeout(function () {
            if ($(this).hasClass('play-sound')) {
                $(this).background("unmute");
                console.log('test');
            }
        }, 0)


    });

    $('.bg-video-noplay').each(function () {
        var videoData = $(this).data('video');
        var posterData = $(this).data('poster');

        console.log(videoData);

        $(this).background({
            autoPlay: false,
            mute: false,
            source: {
                poster: posterData,
                video: 'https://www.youtube.com/watch?v=' + videoData + '&vq=hd1080'
            }
        });
    });

    $('.dropdown-item').click(function () {
        $(this).toggleClass('clicked');
    });

    $('.dropdown-press .bottom-content .title, .dropdown-press .bottom-content .title-bottom').click(function () {
        $(this).closest('.bottom-content').toggleClass('clicked');
    });

    $(".select-holder select").change(function () {
        var target = $(this).val();
        $('.location-item').fadeOut().promise().done(function () {
            $('#' + target).fadeIn();
        });
    });

    $('.pdf-download .top').click(function () {
        $(this).closest('.pdf-download').toggleClass('clicked');
    });

    $('.menu-toggler').click(function () {
        $(this).toggleClass('active');
        $('.responsive-menu').not($('.language')).toggleClass('show');
    })

    //Responsive
    if (window.matchMedia('(max-width: 920px)').matches) {
        $('.case-slider .title').remove().insertBefore('.case-slider').removeClass('title-white').addClass('responsive-title');

        $('.case-slider .default-block').each(function () {
            $(this).find('.left').insertAfter($(this).find('.default-block-right'));
        });

        $('.block-introduction .button').remove().insertAfter('.block-introduction .right');
    }

    $('.bg-video-noplay').click(function (ev) {
        $(this).background("play");
        $(this).addClass('clicked');
        $(this).find('iframe').src += "&autoplay=1";
        ev.preventDefault();
    })

    $('.video-play').click(function () {
        $(this).prev().background("play");
        $(this).prev().addClass('clicked');
        $(this).prev().find('iframe').src += "&autoplay=1";
        $(this).addClass("hidden");
    });


    if (window.matchMedia('(max-width: 920px)').matches) {
        $(window).scroll(function () {
            colorslider();
        })
    }

    if($('.hidden-pdf').length){

        $('.hidden-pdf').each(function(){
            $(this).val($(this).closest('.pdf-download').data('pdf'));
        });
    }

    $('.dropdown-top').click(function(){
        console.log('test');
        $(this).toggleClass('active');
        $('.responsive-menu.language').toggleClass('show');
    });
});

